module.exports = __webpack_public_path__ + "static/media/HPSimplifiedW01-Light.d587d1c1.woff";